import { useParams } from 'react-router-dom';
import { RoleForm } from '@/components/role-form/RoleForm';

const RoleFormPage = () => {
  const { roleId } = useParams<{ roleId: string }>();

  return <RoleForm roleId={roleId} />;
};

export default RoleFormPage;